import {
	AUTH_MODAL_HIDE,
	AUTH_MODAL_SHOW,
	AUTH_CHECK_USER,
	AUTH_FLUSH_USER,
	AUTH_USER_DETAILS,
} from '../types';

const INITIAL_STATE = {
	authenticated: false,
	user: null,
	details: null,
	visible: false,
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case AUTH_MODAL_SHOW:
			return {
				...state,
				visible: true,
			};
		case AUTH_MODAL_HIDE:
			return {
				...state,
				visible: false,
			};
		case AUTH_CHECK_USER:
			return {
				...state,
				user: action.payload,
				authenticated: true,
			};
		case AUTH_FLUSH_USER:
			return {
				authenticated: false,
				user: null,
			};
		case AUTH_USER_DETAILS:
			return {
				...state,
				details: action.payload,
			};
		default:
			return state;
	}
};
